import { render } from "./DrinkSelector.vue?vue&type=template&id=612c2f63&scoped=true&ts=true"
import script from "./DrinkSelector.vue?vue&type=script&lang=ts"
export * from "./DrinkSelector.vue?vue&type=script&lang=ts"

import "./DrinkSelector.vue?vue&type=style&index=0&id=612c2f63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612c2f63"]])

export default __exports__